import util from '../lib/util';
import * as consts from '../constants';

export function checkAccount(accountNumber) {
    return { type: 'CHECK_ACCOUNT', accountNumber };
}

export function createAccount(model) {
    return { type: 'CREATE_ACCOUNT', data: model };
}

export function searchAccount(model) {
    return { type: 'SEARCH_ACCOUNT', data: model };
}

export function updateAccount(businessPartnerModel, businessAgreementModel) {
    return { type: 'UPDATE_ACCOUNT', data: { businessPartnerModel, businessAgreementModel } };
}

export function verifyAccount(verifyfield, verifyvalue) {
    let finalValue = verifyvalue;
    switch (verifyfield) {
        case "Date of birth":
            finalValue = finalValue.replace(/\//g, '-');
            break;
        case "Primary phone number":
        case "Primary cell phone":
        case "Secondary phone number":
        case "Secondary cell phone":
            finalValue = finalValue.replace(/-/g, '');
            break;
    }
    return { type: 'VERIFY_ACCOUNT', verifyfield, verifyvalue: finalValue };
}

export function nextStepClicked(activeIndex) {
    return { type: 'NEXT_STEP_CLICKED', activeIndex };
}
export const ProjectDetailReceived = (data, isCopy) => {
    const serverModel = data.model;
    let reasonType, siteLat, siteLong, otherReasons, demolishReasonType, vacantType, checkConfirm
        , isOwner, projectEmail = '', updatesEmail, notificationEmail, additionalNotes, projectObstacles, workSiteNote, heatingSystem, ageOfProperty, isSameWorkSiteContact;

    //"#removingreason  : I am demolishing the building #customersubtype : 1 #sitelatlong : 48.4152644, -123.380735 #otherreason :   #demolitionplans : I’m subdividing the lot   #IsEmailNewsAllowed : True #IsEmailNotificationAllowed : False #ProjectNotificationEmail : i@aa.aa #sbuildingvacant : $False #technicalNotes"

    if (serverModel && serverModel.notes) {
        serverModel.notes.forEach((note) => {
            if (serverModel.applicationType == consts.SERVICE_REMOVAL_NAME_APLLICATION_TYPE) {
                if (!reasonType)
                    reasonType = util.getIdFromNote(note, "removingreason", window.osa.lookup.serviceAddress.reasonTypes.items) || reasonType;
                if (!otherReasons)
                    otherReasons = util.getIdFromNote(note, "otherreason") || otherReasons;
                if (!demolishReasonType)
                    demolishReasonType = util.getIdFromNote(note, "demolitionplans", window.osa.lookup.serviceAddress.demolishReasonTypes.items) || demolishReasonType;
            }
            else if (serverModel.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE) {
                if (!projectObstacles)
                    projectObstacles = util.getIdFromNote(note, "project obstacles") || projectObstacles;
                if (!heatingSystem)
                    heatingSystem = util.getIdFromNote(note, "HeatingSystem") || heatingSystem;
                if (!ageOfProperty)
                    ageOfProperty = util.getIdFromNote(note, "AgeOfProperty") || ageOfProperty;
            }
            workSiteNote = util.getIdFromNote(note, "worksite contact") || workSiteNote;

            if (!siteLat) {
                let sitelatlong = util.getIdFromNote(note, "sitelatlong") || sitelatlong;
                if (sitelatlong) {
                    sitelatlong = sitelatlong.split(',');
                    if (sitelatlong.length == 2) {
                        siteLat = sitelatlong[0].trim();
                        siteLong = sitelatlong[1].trim();
                    }
                }
            }
            if (!isOwner)
                isOwner = util.getIdFromNote(note, "customersubtype") || isOwner;
            if (!projectEmail)
                projectEmail = util.getIdFromNote(note, "ProjectNotificationEmail") || projectEmail;
            if (!updatesEmail)
                updatesEmail = util.getIdFromNote(note, "IsEmailNewsAllowed") || updatesEmail;
            if (!notificationEmail)
                notificationEmail = util.getIdFromNote(note, "IsEmailNotificationAllowed") || notificationEmail;
            if (!additionalNotes)
                additionalNotes = util.getIdFromNote(note, "AdditionalNotes") || additionalNotes;
            if (!isSameWorkSiteContact)
                isSameWorkSiteContact = util.getIdFromNote(note, "IsSameWorkSiteContact") || isSameWorkSiteContact;
            if (!vacantType) {
                vacantType = util.getIdFromNote(note, "Isbuildingvacant") || vacantType;
                if (vacantType && vacantType == "$False") {
                    vacantType = '2';
                    checkConfirm = 1;
                } else if (vacantType && vacantType == "$True") {
                    vacantType = '1';
                    checkConfirm = 0;
                }
            }
        });
    }

    let worksite = { workSiteContact: 1 };
    if (serverModel.primarySiteContact && serverModel.primarySiteContact.name) {
        let workSiteContact, workSiteContactName, workSiteContactPhone, workSiteContactPhone_ext, workSiteCellPhone, workSiteContactPoistion;
        workSiteContact = isSameWorkSiteContact && isSameWorkSiteContact == 'True' ? 1 : 2;
        workSiteContactName = serverModel.primarySiteContact.name;
        const temp = util.parseCafePhoneNumber(serverModel.primarySiteContact.workPhone);
        if (temp) {
            workSiteContactPhone = temp.phone;
            workSiteContactPhone_ext = temp.ext;
        }
        workSiteCellPhone = serverModel.primarySiteContact.cellPhone;
        if (workSiteNote)
            workSiteContactPoistion = workSiteNote.substring(workSiteNote.indexOf('Position:') + 9);
        worksite = { workSiteContact, workSiteContactName, workSiteContactPhone, workSiteContactPhone_ext, workSiteCellPhone, workSiteContactPoistion };
    }

    let siteAddress = null;
    if (serverModel.siteAddress) {
        const ad = serverModel.siteAddress;
        siteAddress = {
            unitNumber: ad.unitNumber,
            //addressList:,                
            siteAddress_unitNumber: ad.unitNumber,
            siteAddress_streetNumber: ad.streetNumber,
            siteAddress_streetName: ad.streetName,
            siteAddress_streetType: ad.streetType,
            siteAddress_streetDirection: ad.streetDirection,
            siteAddress_city: ad.city,
            siteAddress_state: "BC",
            siteAddress_country: "CA",
            siteAddress_zip: ad.postCode,
        };
    }

    let gasModel = {
        isResume: true,
        project: { data: { projectNo: serverModel.projectNo } },
        activeIndex: serverModel.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE ? 3 : 2,
        bupaCreated: true,
        baNumber: serverModel.baNumber
    };
    let appliances = {};
    if (serverModel.premise1 && serverModel.premise1.appliances) {
        serverModel.premise1.appliances.map(x => appliances[util.mapApplianceName(x.type.toString())] = x.quantity ? x.quantity.toString() : "0");
    }
    let appliances2 = {};
    if (serverModel.premise2 && serverModel.premise2.appliances) {
        serverModel.premise2.appliances.map(x => appliances2[util.mapApplianceName(x.type.toString()) + "2"] = x.quantity ? x.quantity.toString() : "0");
    }
    let secondUnitNo = serverModel.premise2 && serverModel.premise2.unit;
    if (secondUnitNo == serverModel.siteAddress.unitNumber) { // sometimes premise order changes in cafe
        secondUnitNo = serverModel.premise1 && serverModel.premise1.unit;
        let appliances = {};
        if (serverModel.premise2 && serverModel.premise2.appliances) {
            serverModel.premise2.appliances.map(x => appliances[util.mapApplianceName(x.type.toString())] = x.quantity ? x.quantity.toString() : "0");
        }
        let appliances2 = {};
        if (serverModel.premise1 && serverModel.premise1.appliances) {
            serverModel.premise1.appliances.map(x => appliances2[util.mapApplianceName(x.type.toString()) + "2"] = x.quantity ? x.quantity.toString() : "0");
        }
    }
    let duplexSecondAddress = !serverModel.isSingleMeter && serverModel.siteAddress ?
        {
            isPoBox: false,
            duplexSecondAddress_unitNumber: secondUnitNo,
            duplexSecondAddress_streetNumber: serverModel.premise2 && serverModel.premise2.civic,
            duplexSecondAddress_streetName: serverModel.siteAddress.streetName,
            duplexSecondAddress_streetType: serverModel.siteAddress.streetType || "",
            duplexSecondAddress_streetDirection: serverModel.siteAddress.streetDirection || "",
            duplexSecondAddress_city: serverModel.siteAddress.city,
            duplexSecondAddress_province: "BC",
            duplexSecondAddress_zip: serverModel.siteAddress.postCode,
            duplexSecondAddress_poBox: null,
            duplexSecondAddress_country: "CA"
        }
        : null;



    let dpLookup = null;
    let gasDP = null;
    if (serverModel.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE) {
        dpLookup = serverModel.siteAddress.city == 'Revelstoke' ? window.osa.lookup.projectSpecifics.gasDeliveryPressure.itemsRevelstoke :
            window.osa.lookup.projectSpecifics.gasDeliveryPressure.items;
        gasDP = util.getIdByNameContains(serverModel.deliveryPressure, dpLookup);
    }
    const temp = serverModel.gasContractor ? util.parseCafePhoneNumber(serverModel.gasContractor.workPhone) : null;

    let gasContractor = serverModel.gasContractor ? {
        contractorCompanyName: serverModel.gasContractor.companyName,
        contractorName: serverModel.gasContractor.name,
        contractorPrimaryPhone: temp ? temp.phone : null,
        contractorPrimaryPhone_ext: temp ? temp.ext : null,
        contractorSecondaryPhone: serverModel.gasContractor.cellPhone
    } : null;

    if (isCopy) {
        let formModel =
            serverModel.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE ?
                {
                    additionalNotes,
                    isOwner,
                    projectNotificationsEmail_IsSame: (projectEmail == '' ? 1 : 0),
                    projectNotificationsEmail: projectEmail,
                    projectNotificationsEmail_2: projectEmail,
                    electronicCommunicationfromMarketing_UpdatesEmail: (updatesEmail && (updatesEmail == "True")) ? 1 : 0,
                    electronicCommunicationfromMarketing_NotificationEmail: (notificationEmail && (notificationEmail == "True")) ? 1 : 0,
                    ...worksite,
                    meterLocation: serverModel.meterLocation,
                    buildingType: serverModel.buildingType == 'Single' ? "1" : "2",
                    buildingCondition: serverModel.isNewBuilding ? "New" : "Existing",
                    duplexMeterCount: serverModel.isSingleMeter ? "1" : "2",
                    heatingSystem,
                    ageOfProperty,
                    billingMethod_termCheck: "1",
                    differentDeliveryPressure: serverModel.deliveryPressure && serverModel.deliveryPressure != '' && gasDP != dpLookup[0].id ? "1" : "0",
                    gasDeliveryPressure: serverModel.deliveryPressure && serverModel.deliveryPressure != '' ? gasDP : "0",
                    ["Large trees"]: projectObstacles && projectObstacles.includes("Large trees") ? "1" : "0",
                    ["Ditches"]: projectObstacles && projectObstacles.includes("Ditches") ? "1" : "0",
                    ["Retaining walls"]: projectObstacles && projectObstacles.includes("Retaining walls") ? "1" : "0",
                    ["Septic tanks"]: projectObstacles && projectObstacles.includes("Septic tanks") ? "1" : "0",
                    ["Oil tanks"]: projectObstacles && projectObstacles.includes("Oil tanks") ? "1" : "0",
                    ["OtherObstacle"]: projectObstacles && projectObstacles.split(',').find((elem) => elem != 'Large trees' && elem != 'Ditches' && elem != 'Retaining walls' && elem != 'Septic tanks' && elem != 'Oil tanks'),
                    buildingFootage: serverModel.premise1 && serverModel.premise1.squareFootage,
                    buildingFootage2: serverModel.premise2 && serverModel.premise2.squareFootage,
                    ...appliances,
                    ...appliances2,
                    ...duplexSecondAddress,
                    ...gasContractor,
                    "Built1990": serverModel.built1990 ? serverModel.built1990 == 'Y' ? '1' : '0' : '',
                    "WillActiveConstruction": serverModel.willActiveConstruction ? serverModel.willActiveConstruction == 'Y' ? '1' : '0' : '',
                    "HazardousMaterialsReport": serverModel.hazardousMaterialsReport ? serverModel.hazardousMaterialsReport == 'Y' ? '1' : '0' : ''

                } :
                {
                    ...worksite,
                    //isCustomerSpecifiedDate:,
                };
        return { type: 'PROJECT_DETAIL_RECEIVED', formModel };
    }

    let formModel =
        serverModel.applicationType == consts.NEW_GAS_LINE_NAME_APLLICATION_TYPE ?
            {
                projectNo: serverModel.projectNo,
                siteLat,
                siteLong,
                ...siteAddress,
                additionalNotes,
                isOwner,
                projectNotificationsEmail_IsSame: (projectEmail == '' ? 1 : 0),
                projectNotificationsEmail: projectEmail,
                projectNotificationsEmail_2: projectEmail,
                electronicCommunicationfromMarketing_UpdatesEmail: (updatesEmail && (updatesEmail == "True")) ? 1 : 0,
                electronicCommunicationfromMarketing_NotificationEmail: (notificationEmail && (notificationEmail == "True")) ? 1 : 0,
                ...worksite,
                checkConfirmAddress: "1",
                meterLocation: serverModel.meterLocation,
                buildingType: serverModel.buildingType == 'Single' ? "1" : "2",
                buildingCondition: serverModel.isNewBuilding ? "New" : "Existing",
                duplexMeterCount: serverModel.isSingleMeter ? "1" : "2",
                heatingSystem,
                ageOfProperty,
                billingMethod_termCheck: "1",
                differentDeliveryPressure: serverModel.deliveryPressure && serverModel.deliveryPressure != '' && gasDP != dpLookup[0].id ? "1" : "0",
                gasDeliveryPressure: serverModel.deliveryPressure && serverModel.deliveryPressure != '' ? gasDP : "0",
                ["Large trees"]: projectObstacles && projectObstacles.includes("Large trees") ? "1" : "0",
                ["Ditches"]: projectObstacles && projectObstacles.includes("Ditches") ? "1" : "0",
                ["Retaining walls"]: projectObstacles && projectObstacles.includes("Retaining walls") ? "1" : "0",
                ["Septic tanks"]: projectObstacles && projectObstacles.includes("Septic tanks") ? "1" : "0",
                ["Oil tanks"]: projectObstacles && projectObstacles.includes("Oil tanks") ? "1" : "0",
                ["OtherObstacle"]: projectObstacles && projectObstacles.split(',').find((elem) => elem != 'Large trees' && elem != 'Ditches' && elem != 'Retaining walls' && elem != 'Septic tanks' && elem != 'Oil tanks'),
                buildingFootage: serverModel.premise1 && serverModel.premise1.squareFootage,
                buildingFootage2: serverModel.premise2 && serverModel.premise2.squareFootage,
                ...appliances,
                ...appliances2,
                ...duplexSecondAddress,
                ...gasContractor
            } :
            {
                projectNo: serverModel.projectNo,
                siteLat,
                siteLong,
                ...siteAddress,
                checkConfirmAddress: 1,
                reasonType,
                otherReasons,
                demolishReasonType,
                vacantType,
                checkConfirm,
                additionalNotes,
                isOwner,
                projectNotificationsEmail_IsSame: (projectEmail == '' ? 1 : 0),
                projectNotificationsEmail: projectEmail,
                projectNotificationsEmail_2: projectEmail,
                electronicCommunicationfromMarketing_UpdatesEmail: (updatesEmail && (updatesEmail == "True")) ? 1 : 0,
                electronicCommunicationfromMarketing_NotificationEmail: (notificationEmail && (notificationEmail == "True")) ? 1 : 0,
                ...worksite,
                ...gasContractor,
                "Built1990": serverModel.built1990 ? serverModel.built1990 == 'Y' ? '1' : '0' : '',
                "WillActiveConstruction": serverModel.willActiveConstruction ? serverModel.willActiveConstruction == 'Y' ? '1' : '0' : '',
                "HazardousMaterialsReport": serverModel.hazardousMaterialsReport ? serverModel.hazardousMaterialsReport == 'Y' ? '1' : '0' : ''
                //isCustomerSpecifiedDate:,
            };
    return { type: 'PROJECT_DETAIL_RECEIVED', gasModel, formModel };
};

export const setGoogleLocation = (place, siteAddress) => {
    const address = `${siteAddress.streetNumber} ${siteAddress.streetName} ${siteAddress.streetType} ${siteAddress.city} BC CA ${siteAddress.postCode}`;
    return { type: "SET_GOOGLE_LOCATION", place, address };
};

export const serviceLocationChanged = (productName) => {
    switch (productName) {
        case consts.NEW_GAS_LINE_NAME:
            return { type: 'checkbox', name: 'checkConfirmAddress', value: 0 };
        case consts.SERVICE_REMOVAL_NAME:
            return { type: 'checkbox', name: 'checkConfirmAddress', value: 0 };
    }
};
